import React from 'react';
import PropTypes from 'prop-types';
import scrollToComponent from 'react-scroll-to-component';

import Awclogo from 'images/logo-white.svg';
import logoAfterHours from 'images/logo-afterhours-nav.png';
import { StyledHeader } from './styles';

class Header extends React.Component {
  scrollToSection = (ref) => {
    scrollToComponent(document.getElementById(ref), { offset: 0, align: 'top', duration: 500 });
  }
  render() {
    return (
      <StyledHeader>
        <div className="logo-awc">
          <a href="https://affiliateworldconferences.com">
            <img src={Awclogo} alt="AWC Logo" />
          </a>
        </div>
        <div className="logo-afterhours" style={{ opacity: this.props.logo ? 1 : 0 }}>
          <img src={logoAfterHours} alt="Affiliate After Hours Logo" />
        </div>
        { this.props.rsvp ? (
          <div className="rsvp">
            <button onClick={() => { this.scrollToSection('rsvp'); }}>RSVP Now</button>
          </div>
        ) : null }
      </StyledHeader>
    );
  }
}

Header.propTypes = {
  logo: PropTypes.bool.isRequired,
  rsvp: PropTypes.bool.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js